import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import Business from "../pages/Business";
import Healthcare from "../pages/Healthcare";
import Education from "../pages/Education";
import Commerce from "../pages/Commerce";
import Professional from "../pages/Professional";
import Finance from "../pages/Finance";
import Tax from "../pages/Tax";
import "./Products.css";
import Cosection from '../components/Cosections';
import Scrolltop from '../components/Scrolltop';
import WhatsAppChatButton from '../components/Whatsapp';

const Products = ({ showQuoteModal, setShowQuoteModal }) => {
  const [activeCategory, setActiveCategory] = useState(null);
  const [heights, setHeights] = useState({});
  const categoryRefs = useRef({});
  const contentRefs = useRef({});
  const location = useLocation();
  const navigate = useNavigate();
  const modalIntervalRef = useRef(null);
  const scrollPositionRef = useRef(0);

  const categories = [
    { id: 1, name: "Business & Operations", component: <Business />, slug: "business-operations" },
    { id: 2, name: "Healthcare & Wellness", component: <Healthcare />, slug: "healthcare-wellness" },
    { id: 3, name: "Education & Learning", component: <Education />, slug: "education-learning" },
    { id: 4, name: "Commerce & Retail", component: <Commerce />, slug: "commerce-retail" },
    { id: 5, name: "Professional & Creative Services", component: <Professional />, slug: "professional-services" },
    { id: 6, name: "Finance & Utility", component: <Finance />, slug: "finance-utility" },
    { id: 7, name: "Tax & Legal Services", component: <Tax />, slug: "tax-legal" }
  ];

  // Initialize refs and measure heights
  useEffect(() => {
    const updateHeights = () => {
      const newHeights = {};
      categories.forEach(category => {
        const contentRef = contentRefs.current[category.id];
        if (contentRef) {
          newHeights[category.id] = contentRef.scrollHeight;
        }
      });
      setHeights(newHeights);
    };

    updateHeights();

    // Function to show modal only if not currently showing
    const showModalIfNotOpen = () => {
      if (!showQuoteModal) {
        // Save current scroll position before opening modal
        scrollPositionRef.current = window.pageYOffset;
        setShowQuoteModal(true);
      }
    };

    // Start interval only if modal is not currently open
    if (!showQuoteModal) {
      modalIntervalRef.current = setInterval(showModalIfNotOpen, 120000); // 2 minutes
    }

    return () => {
      // Clear interval on unmount
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
        modalIntervalRef.current = null;
      }
    };
  }, [showQuoteModal, setShowQuoteModal]);

  // Restore scroll position when modal closes
  useEffect(() => {
    if (!showQuoteModal && scrollPositionRef.current > 0) {
      window.scrollTo(0, scrollPositionRef.current);
      scrollPositionRef.current = 0;
    }
  }, [showQuoteModal]);

  // Additional effect to restart interval when modal closes
  useEffect(() => {
    if (!showQuoteModal && !modalIntervalRef.current) {
      modalIntervalRef.current = setInterval(() => {
        if (!showQuoteModal) {
          setShowQuoteModal(true);
        }
      }, 120000);
    }
    
    return () => {
      if (modalIntervalRef.current) {
        clearInterval(modalIntervalRef.current);
        modalIntervalRef.current = null;
      }
    };
  }, [showQuoteModal, setShowQuoteModal]);

  // Handle hash-based navigation
  useEffect(() => {
    const hash = location.hash.replace('#', '');
    if (hash) {
      const category = categories.find(cat => cat.slug === hash);
      if (category) {
        setActiveCategory(category.id);
        setTimeout(() => {
          const element = document.getElementById(`category-${category.id}`);
          if (element) {
            const yOffset = -100; // Adjust for header
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }, 300);
      }
    }
  }, [location]);

const toggleCategory = (categoryId, categorySlug) => {
  console.log(`Toggling category ${categoryId}, currently active: ${activeCategory}`);
  const newActive = activeCategory === categoryId ? null : categoryId;
  console.log(`New active state: ${newActive}`);
  setActiveCategory(newActive);
  navigate(`#${newActive ? categorySlug : ''}`, { replace: true });
};

  return (
    <>
      <Navigation />
      <div className="kr-products">
        <div className="kr-products__header">
          <h1 className="kr-products__title">Our Product Solutions</h1>
          <p className="kr-products__subtitle">
            Discover our comprehensive suite of digital solutions designed to transform operations across industries. 
            Click on any category below to explore specialized tools for your business needs.
          </p>
        </div>

        <div className="kr-products__categories">
          {categories.map((category) => (
            <div 
              key={category.id} 
              id={`category-${category.id}`}
              ref={el => categoryRefs.current[category.id] = el}
              className={`kr-products__category ${activeCategory === category.id ? 'is-active' : ''}`}
            >
              <div 
                className="kr-products__category-header"
                onClick={() => toggleCategory(category.id, category.slug)}
              >
                <h2 className="kr-products__category-title">{category.name}</h2>
                <span className="kr-products__category-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </span>
              </div>
              
              <div 
                className="kr-products__category-content"
                style={{
                  height: activeCategory === category.id ? `${heights[category.id] || 'auto'}px` : '0px',
                  overflow: 'hidden',
                  transition: 'height 0.3s ease-in-out'
                }}
              >
                <div 
                  className="kr-products__category-inner"
                  ref={el => contentRefs.current[category.id] = el}
                >
                  {category.component}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Scrolltop />
      <WhatsAppChatButton />
      <Cosection setShowQuoteModal={setShowQuoteModal} />
      <Footer />
    </>
  );
};

export default Products;